var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTestCodingBlue = function SvgIconTestCodingBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 9.334H11.667a2.333 2.333 0 0 0-2.334 2.333v36.167a2.333 2.333 0 0 0 2.334 2.333h32.666a2.333 2.333 0 0 0 2.334-2.333V11.667a2.333 2.333 0 0 0-2.334-2.333Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.834H21c-.644 0-1.167.522-1.167 1.167v4.666c0 .645.523 1.167 1.167 1.167h14c.644 0 1.167-.522 1.167-1.167V7.001c0-.645-.523-1.167-1.167-1.167Z",
    fill: "#2C6CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.488 28.902-3.919-3.918a1.604 1.604 0 0 0-2.269 2.269l3.919 3.918a1.604 1.604 0 0 0 2.269-2.268Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m37.22 28.91-3.918 3.919a1.604 1.604 0 1 0 2.268 2.268l3.919-3.918a1.604 1.604 0 0 0-2.269-2.269ZM18.78 31.172l3.918-3.919a1.604 1.604 0 0 0-2.269-2.268l-3.918 3.918a1.604 1.604 0 1 0 2.268 2.269Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.512 31.178 3.918 3.918a1.604 1.604 0 0 0 2.27-2.268l-3.92-3.919a1.604 1.604 0 1 0-2.268 2.269ZM27.94 25.519l-2.893 7.948a1.604 1.604 0 1 0 3.015 1.098l2.892-7.949a1.604 1.604 0 0 0-3.014-1.097Z",
    fill: "#fff"
  })));
};
export default SvgIconTestCodingBlue;